(() => {
  const form = document.getElementById('ContactForm');
  const context = form?.querySelector('[data-item-question-form]');
  const body = form?.querySelector('#ContactForm-body');
  if (!context || !body || body.value.trim()) return;
  const params = new URLSearchParams(window.location.search);
  const handle = params.get('product') || '';
  const title = (params.get('item') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 240);
  if (!/^[a-z0-9][a-z0-9-]{0,180}$/.test(handle) || !title) return;
  const root = context.dataset.shopRoot || '/';
  const path = root.replace(/\/$/, '') + '/products/' + handle;
  body.value = [context.dataset.questionIntro, title, window.location.origin + path, '', context.dataset.questionPrompt, ''].join('\n');
  const note = context.querySelector('[data-item-question-note]');
  if (note) note.hidden = false;
})();
